"use client";
import { Controller, useForm } from "react-hook-form";
import BoxWithTitle from "../BoxWithTitle";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import { useSubscribeBlogsQuery } from "@/api/AppApi/services/blogs";
import { useTranslation } from "@/hooks/localization/useTranslations";
import useEventTrackers from "@/utils/helpers/pixel-helpers/hooks/useEventTrackers/useEventTrackers";

const SubscribeForm = () => {
  const t = useTranslation();
  const { handleSubmit, control, formState, reset } = useForm();
  const { GTagMaillistConversionEventTracher } = useEventTrackers();
  const subscribeBlogs = useSubscribeBlogsQuery({
    onSuccess: () => {
      reset({ email: "" });
    },
    onError: (_err: any) => {
    },
  });
  const onSubmit = (data: any) => {
    subscribeBlogs.mutate(data);
    GTagMaillistConversionEventTracher(data?.email);
  };
  return (
    <BoxWithTitle title={t.subscribe_to_our_blog}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="subscribe-input">
          <div className="input-container">
            <Controller
              name="email"
              control={control}
              rules={{
                required: t.this_field_is_required,
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: t.invalid_email_address,
                },
              }}
              render={({ field }) => (
                <input
                  {...field}
                  type="email"
                  id="email"
                  placeholder={t.enter_your_email}
                />
              )}
            />
            {formState?.errors.email && (
              <div className="auth-err">
                {formState?.errors?.email?.message?.toString()}
              </div>
            )}
          </div>
          <div className="w-100 d-flex justify-content-end">
            <CustomButton
              isSubmit
              type={BtnTypes.primary}
              size={BtnSizes.medium}
              radius={BtnRadius.small}
            >
              {t.subscribe}
            </CustomButton>
          </div>
        </div>
      </form>
    </BoxWithTitle>
  );
};

export default SubscribeForm;
